import { useEffect, useState } from "react";
import Table from "../Common/Table";
import PopUp from "../Common/PopUp";
import { showToast } from "../Common/Messages";

const VersionSetting = (props) => {
    const [viewList, setViewList] = useState([]);
    const [listTitle, setListTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    const [groupList, setGroupList] = useState([]);
    const [newGroup, setNewGroup] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editName, setEditName] = useState('');
    const [showContextMenu, setShowContextMenu] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [checkedItems, setCheckedItems] = useState(new Set());
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);

    useEffect(() => {
        fetch("datas/oper/categorytype.json")
        .then((response) => response.json())
        .then((json) => {
            const sorted = json
            .sort((a, b) => a.type.localeCompare(b.type));
            setGroupList(sorted);
        });
    }, []);

    useEffect(() => {
        if(groupList.length) {
            setListTitle(groupList[selectedIndex].type);
            setViewList(groupList[selectedIndex].version);
        }
    }, [selectedIndex, groupList]);

    useEffect(() => {
        if (isUpdate) {
            saveVersion(groupList[selectedIndex].type, viewList);
            setIsUpdate(false);
        }
    }, [viewList, isUpdate]);

    const handleAddGroup = () => {
        if (!newGroup || newGroup.trim() === '') return;
        groupList.push({type: newGroup, version: []})
        SaveCategoryGroup(groupList);
        setNewGroup(null);
    };

    const handleDeleteGroup = (groupType) => {
        const category = groupList.filter(x => x.type !== groupType);
        SaveCategoryGroup(category);
        setShowContextMenu(null);
    };

    const handleEditGroup = (index) => {
        setEditingIndex(index);
        setEditName(groupList[index].type);
        setShowContextMenu(null);
    };

    const handleSaveEdit = (index) => {
        if (!editName || editName.trim() === '') return;
        groupList[index].type = editName;
        SaveCategoryGroup(groupList);
        setEditingIndex(null);
    };

    const handleSelectGroup = (index) => {
        setIsCheckedAll(false);
        setCheckedItems(new Set());
        setSelectedIndex(index);
    };

    const SaveCategoryGroup = (category) => {
        fetch('api/Manager/SaveCategoryGroup', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                menuPath: "/categorytype",
                menuTreeJson: JSON.stringify(category)
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    setGroupList(JSON.parse(data));
                }
            })
            .catch(error => {throw new Error('Error saving category group: ' + error);});
    };

    const renderBatchWrap = () => {
        let batchWrapArr = [];
        batchWrapArr.push(
            <p key="batch" className="count"><span className="selected">{checkedItems.size}</span>/{viewList.length} 선택됨</p>
        );
        return batchWrapArr;
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    
    const handleMouseDown = (event) => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    const btnOnPopup = (e, item, index) => {
        setPopupContent(item !== null && item !== undefined
            ? renderMoreMenu(item, index) : null);
    }

    const renderMoreMenu = (item, index) => {
        return (
            <div className="layer-list admin-more-menu" style={{ top: position.y + 'px', left: position.x + 'px' }}>
                <div className="box">
                    <ul>
                        <li><a onClick={e => DeleteVersion(item, index)}>버전 삭제</a></li>
                    </ul>
                </div>
            </div>
        );
    }

    const [draggedNode, setDraggedNode] = useState(null);
    const [dragOverNodeId, setDragOverNodeId] = useState(null);
    const [dropAction, setDropAction] = useState({});

    // 자기 자신 또는 children으로 드래그 방지
    const isDescendant = (parent, child) => {
        if (parent === child) return true;
        return false;
    };

    const onDragStart = (e, node) => {
        e.stopPropagation();
        setDraggedNode(node);
    };

    const onDrop = (e, targetNode) => {
        e.preventDefault();
        e.stopPropagation();

        if (!draggedNode || draggedNode === targetNode) return;

        // 자기 자신의 child로 드래그 방지
        if (isDescendant(draggedNode, targetNode)) {
            setDropAction({});
            return;
        }

        updateVersionPosition(draggedNode, targetNode, dropAction)

        setDraggedNode(null);
        setDragOverNodeId(null);
        setDropAction({});
    };

    const onDragOver = (e, targetNode) => {
        e.preventDefault();
        e.stopPropagation();

        // 자기 자신의 child로 드래그 방지
        if (draggedNode && isDescendant(draggedNode, targetNode)) {
            setDropAction({});
            return;
        }

        const rect = e.target.getBoundingClientRect();
        const offsetY = e.clientY - rect.top;
        const height = rect.height;

        if (offsetY < height * 0.5) {
            // 위 가장자리: move 위
            setDropAction({ above: true, below: false });
        } else if (offsetY >= height * 0.5) {
            // 아래 가장자리: move 아래
            setDropAction({ above: false, below: true });
        }

        setDragOverNodeId(targetNode);
    };

    const updateVersionPosition = (draggedNode, targetNode, dropAction) => {
        if(viewList.length === 0) return;
        setViewList((prev) => {
            const removeNode = (nodes, ver) => {
                const result = [];
                let removedNode = null;
                for (const node of nodes) {
                    if (node === ver) {
                        removedNode = node;
                    } else {
                        result.push(node);
                    }
                }
                return { updatedChildren: result, removed: removedNode };
            };

            const addNode = (nodes, ver, newNode, position) => {
                return nodes.map((node) => {
                    if (node === ver) {
                        if (dropAction.above) {
                            return [newNode, node];
                        } else if (dropAction.below) {
                            return [node, newNode];
                        }
                    }
                    return node;
                }).flat();
            };

            const prevData = prev;
            const { updatedChildren, removed } = removeNode(prevData, draggedNode);
            if (!removed) return prevData;
            const position = dropAction.above || dropAction.below;

            let newData = prevData;
            if (position) {
                newData = addNode(updatedChildren, targetNode, removed, dropAction);
            }
            return newData;
        });
        setIsUpdate(true);
    }

    const saveVersion = (groupType, versionList) => {
        const categoryInfo = groupList.map(c => { 
            if (c.type === groupType) {
                return {...c, version: versionList}; 
            }
            else return c; 
        });
        fetch('api/Manager/SaveVersion', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                menuPath: '/categorytype',
                menuTreeJson: JSON.stringify(categoryInfo)
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.message === "Success") {
                    showToast('success', '저장되었습니다.', 3000);
                    setGroupList(categoryInfo);
                    setIsCheckedAll(false);
                    setCheckedItems(new Set());
                    setPopupContent(null);
                }
            })
            .catch(error => {throw new Error('Error saving version: ' + error);});
    };

    const DeleteVersion = (version, index) => {
        setViewList(prev => prev.filter(v => v !== version));
        setIsUpdate(true);
    }

    const openAddVersionPopup = () => {
        setPopupContent(
            <AddVersion
                onClose={setPopupContent}
                versionList={viewList}
                groupType={groupList[selectedIndex].type}
                saveVersion={saveVersion}
            />
        );
    };

    const setHeaders = () => {
        return [
            "",
            "버전",
            ""
        ];
    };

    const dragStyle = (node, ver, dropAction) => {
        const borderTop = node !== draggedNode && node === ver && dropAction.above ? "2px solid #007bff" : "1px solid #eaeaea";
        const borderBottom = node !== draggedNode && node === ver && dropAction.below ? "2px solid #007bff" : "none";
        return {
            borderTop,
            borderBottom
        }
    }
    
    const renderVersionList = () => {
        let list = [];
        for (let i = 0; i < viewList.length; i++) {
            list.push(
                <tr key={i}>
                    <td 
                        draggable
                        onDragStart={e => onDragStart(e, viewList[i])}
                        onDragOver={e => onDragOver(e, viewList[i])}
                        onDrop={e => onDrop(e, viewList[i])}
                        style={dragStyle(dragOverNodeId, viewList[i], dropAction)}
                    >
                        <i className="icoKdc16 hamburger" style={{marginLeft: "20px"}}></i>
                    </td>
                    <td style={dragStyle(dragOverNodeId, viewList[i], dropAction)}>{viewList[i]}</td>
                    <td style={dragStyle(dragOverNodeId, viewList[i], dropAction)}><button className="btn-admin-more" onClick={e => btnOnPopup(e, viewList[i], i)}><i className="i-btn-more"></i></button></td>
                </tr>
            );
        }
        return list;
    }
    const list = renderVersionList();

    return (
        <div className="content-scroll">
            <div className="content" onMouseDown={handleMouseDown}>
                <div className="content-left">
                    <div className="list-top">
                        <h3 className='list-title'>버전 관리</h3>
                        <button className='btn-add' onClick={() => setNewGroup('')}>
                            <i className='icoKdc24 add-24'></i>
                        </button>
                    </div>
                    <ul className='group-list'>
                        {groupList.map((group, index) => (
                            <li className={`group-item ${selectedIndex === index ? 'selected' : ''}`} key={index} onClick={() => handleSelectGroup(index)}>
                                <div className="group-name-wrap">
                                    <i className='icoKdc20 user'></i>
                                    {editingIndex === index ? (
                                        <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus placeholder="그룹명을 입력하세요" />
                                    ) : (
                                        <p className='group-name'>{group.type}</p>
                                    )}
                                </div>
                            </li>
                        ))}
                        {newGroup !== null && (
                            <li className='group-item'>
                                <div className="group-name-wrap">
                                    <i className="icoKdc20 user"></i>
                                    <input type="text" value={newGroup} onChange={(e) => setNewGroup(e.target.value)} autoFocus placeholder="그룹명을 입력하세요" />
                                </div>
                                <button className="btn-cancel" onClick={() => setNewGroup(null)}>취소</button>
                                <button className="btn-add" onClick={handleAddGroup}>확인</button>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="content-right">
                    <h3 className='list-title mb-12'>{listTitle}</h3>
                    <div className="list-tools">
                        <div className={`btns-wrap ${selectedIndex === -1 ? "dis" : ""}`}>
                            <button className='btn-appr' onClick={openAddVersionPopup}>
                                <i className='icoKdc12 add-12'></i>버전 추가
                            </button>
                            {checkedItems.size > 0 ? renderBatchWrap() : null}
                        </div>
                    </div>
                    <Table className={"customerlist"} headers={setHeaders()} list={list} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
};

const AddVersion = (props) => {
    const [searchValue, setSearchValue] = useState('');
    const [versionListState, setVersionListState] = useState(props.versionList);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addVersionToList();
        }
    };

    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const addVersionToList = () => {
        if (props.versionList.some(v => v === searchValue)) {
            showToast("warning", "버전이 이미 존재합니다.");
            return;
        }
        setSearchValue('');
        props.saveVersion(props.groupType, [searchValue, ...props.versionList])
    };

    return (
        <div className="msg-popup center-box overflow-unset">
            <div className="modal">
                <div className="modal-top">
                    <h3 className="modal-title">버전 추가</h3>
                    <button className="btn-close" onClick={() => props.onClose(null)}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className="modal-cnts">
                    <form className="search-input" onKeyDown={handleKeyDown}>
                        <i className="icoKdc20 add-g"></i>
                        <input
                            placeholder="버전을 입력하세요."
                            value={searchValue}
                            onChange={handleInputChange}
                        />
                    </form>
                </div>
                <div className="mail-list-btm">
                    <button className="btn-share" onClick={addVersionToList}>
                        완료
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VersionSetting;
